module.exports = __webpack_public_path__ + "static/img/P3.23bd5ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mssj/P3.png
// module id = admT
// module chunks = 0